export enum UserNotificationType {
  RECORDING_FIXED = 'grabacion_corregida',
  LETTER_TO_CREATE = 'letra_por_crear',
  BANK_MATCH_AUTOMATIC = 'conciliacion_automatica',
  ENROLLMENT_WITH_ACTIVE_COURSE = 'inscripcion_con_curso_activo',
}

export interface RecordingFixedNotificationMetadata {
  sessionId?: number;
  groupId?: number;
  notifiedEmails?: string[];
}

export interface LetterToCreateNotificationMetadata {
  studentId?: number;
  letter?: string;
  year?: number;
  academicYearId?: number;
  gradeOfferedId?: number;
  degreeId?: number;
  universityId?: number;
}

export interface EnrollmentWithActiveCourseNotificationMetadata {
  studentId?: number;
  groupId?: number;
  subjectGroupId?: number;
  activeGroupName?: string;
}

export interface UserNotification {
  id: number;
  type: UserNotificationType;
  title: string;
  message: string;
  relatedEntityId?: number;
  relatedEntityType?: string;
  metadata?: RecordingFixedNotificationMetadata &
    LetterToCreateNotificationMetadata &
    EnrollmentWithActiveCourseNotificationMetadata;
  readAt?: string;
  creationDate: string;
}

export interface UnreadCountResponse {
  count: number;
}
